export const widthColName = 300;
export const widthColMetric = 140;
export const widthColTypeIndicator = 4;

export const stylesSticky = {
  position: 'sticky',
  zIndex: 2,
};

export const UA = 1;
export const RE = 2;
// export const ACTIVITY_TYPES_COLORS = {
//   [UA]: '#98B7D8',
//   [RE]: '#FFAF00',
// };
